// extracted by css-extract-rspack-plugin
export default {"wrap":"wrap-YJJq56","sectionTitle":"sectionTitle-lWpSBp","sectionTitleText":"sectionTitleText-efKzTj","section":"section-LoMx3x","sectionRow":"sectionRow-zKv_KJ"};